/**
 * How rare or commonly a diagnosis appears.
 */
class Rarity {
  static NONE: Rarity;
  static VERY_COMMON: Rarity;
  static COMMON: Rarity;
  static UNCOMMON: Rarity;
  static RARE: Rarity;
  static VERY_RARE: Rarity;

  private static _values: Rarity[] = [];
  private static _lookup: Map<number, Rarity> = new Map();

  static fromTag(id: number) {
    const rarity = Rarity._lookup.get(id);
    if (rarity === undefined) {
      throw new Error('Not a valid Rarity.id: ' + id);
    }
    return rarity;
  }

  static values(): Rarity[] {
    return [...Rarity._values];
  }

  // --

  public readonly id: number;
  public readonly label: string;
  public readonly min: number;
  public readonly max: number;

  constructor(id: number, label: string, min: number, max: number) {
    this.id = id;
    this.label = label;
    this.min = min;
    this.max = max;
    Rarity._values.push(this);
    Rarity._lookup.set(id, this);
  }

  get isSet() {
    return this.id !== 0;
  }

  toString() {
    return '<Rarity: ' + this.id + ', label=' + this.label + '>';
  }
}

Rarity.NONE = new Rarity(0, 'n/a', -1, -1);
Rarity.VERY_COMMON = new Rarity(1, 'Very common', 10000, 100000);
Rarity.COMMON = new Rarity(2, 'Common', 1000, 10000);
Rarity.UNCOMMON = new Rarity(3, 'Uncommon', 100, 1000);
Rarity.RARE = new Rarity(4, 'Rare', 1, 100);
Rarity.VERY_RARE = new Rarity(5, 'Very rare', 0, 1);

export { Rarity };
